import { mainAxios } from "@/mainAxios";
import { getDefaultHeaders, getErrorMessage } from "@/services/mainService";

export const addTelefonoListaNegra = async (body) => {
  try {
    const response = await mainAxios.post(
      "/v1/telefonoListaNegra",
      body,
      getDefaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getTelefonoListaNegraStatus = async (telefono) => {
  try {
    const response = await mainAxios.get("/v1/telefonoListaNegra/exists", {
      ...getDefaultHeaders(),
      params: { telefono },
    });
    return response.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const desbloquearTelefonoListaNegra = async (id) => {
  try {
    const response = await mainAxios.put(
      "/v1/telefonoListaNegra/changeStatus",
      { id, status: 0 },
      getDefaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
